import Spinner from 'react-bootstrap/Spinner';
import './spinner.component.scss';
const SpinnerComponent = () => {
  return (
    <>
      <div className="spinner-overlay-bg" />
      <div className="spinner-overlay">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    </>
  );
};
export default SpinnerComponent;
